import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-3 py-1 text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-primary-400 focus:ring-offset-2 focus:ring-offset-secondary-950",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary-500/15 text-primary-300",
        secondary: "border-transparent bg-secondary-800/80 text-secondary-300",
        destructive: "border-transparent bg-error-900/40 text-error-300",
        success: "border-success-800/40 bg-success-900/40 text-success-300",
        warning: "border-warning-800/40 bg-warning-900/40 text-warning-300",
        outline: "border-secondary-700/50 text-secondary-300",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
